<script lang="ts">
  import clsx from 'clsx';

  const { sizeClass = 'w-full h-full' }: { sizeClass?: string } = $props();
</script>

<svg
  class={clsx(sizeClass, 'overflow-hidden align-middle')}
  viewBox="0 0 28 28"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M13.986 0.666504C6.62602 0.666504 0.666016 6.63984 0.666016 13.9998C0.666016 21.3598 6.62602 27.3332 13.986 27.3332C21.3593 27.3332 27.3327 21.3598 27.3327 13.9998C27.3327 6.63984 21.3593 0.666504 13.986 0.666504ZM13.9993 24.6665C8.10602 24.6665 3.33268 19.8932 3.33268 13.9998C3.33268 8.1065 8.10602 3.33317 13.9993 3.33317C19.8927 3.33317 24.666 8.1065 24.666 13.9998C24.666 19.8932 19.8927 24.6665 13.9993 24.6665Z"
    fill="currentColor"
  />
  <path
    d="M13.9993 5.99984C15.8438 5.99984 17.3327 7.53486 17.3327 9.43646C17.3327 11.3381 15.8438 12.8731 13.9993 12.8731C12.1549 12.8731 10.666 11.3381 10.666 9.43646C10.666 7.53486 12.1549 5.99984 13.9993 5.99984ZM13.9993 22.2665C11.2216 22.2665 8.76602 20.8002 7.33268 18.5779C7.36602 16.2982 11.7771 15.0496 13.9993 15.0496C16.2105 15.0496 20.6327 16.2982 20.666 18.5779C19.2327 20.8002 16.7771 22.2665 13.9993 22.2665Z"
    fill="currentColor"
  />
</svg>
